import React from 'react';
import '../styles/Footer.css';
import { Link, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import zIndex from '@mui/material/styles/zIndex';

function Footer({ showFooter }) {
    const navigate = useNavigate();

    return (
        <footer className={`footerClass ${showFooter ? 'visible' : ''}`} style={styles.footer}>
            {/* Contenedor para "Hola mundo" */}
            <div style={styles.left}>
                <Typography style={styles.text}>Hola mundo</Typography>
            </div>

            {/* Contenedor para el texto centrado */}
            <div style={styles.center}>
                <Typography style={styles.text}>xetc.top &copy; 2024 | Derechos reservados.</Typography>
            </div>

            {/* Contenedor para los links */}
            <div style={styles.right}>
                <Link onClick={() => navigate("/aviso_privacidad")} style={styles.link}>
                    <Typography style={styles.link}>Aviso de privacidad</Typography>
                </Link>
                <Typography style={styles.separator}>||</Typography>
                <Link onClick={() => navigate("/terminos_condiciones")} style={styles.link}>
                    <Typography style={styles.link}>Términos y condiciones</Typography>
                </Link>
            </div>
        </footer>
    );
}

const styles = {
    footer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '10px 20px',
        backgroundColor: '#222',
        color: '#fff',
        zIndex: 1200,
        height: "60px"
    },
    left: {
        flex: 1,
        textAlign: 'left',
    },
    center: {
        flex: 1,
        textAlign: 'center',
    },
    right: {
        flex: 1,
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: '10px', // Espaciado entre links
    },
    link: {
        color: '#ccccff',
        textDecoration: 'underline',
        cursor: 'pointer',
    },
    separator: {
        color: '#fff',
        margin: '0 5px',
    },
    text: {
        color: '#fff',
    },
};

export default Footer;
